// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__27aYv","header":"ReportDetails_header__2CkeM","title":"ReportDetails_title__1c0br","left":"ReportDetails_left__3IFV3"};